import {
  EmailReportSettings,
  REPORT_OPTIONS,
  SeasonDetails,
} from "@mysnowscape/snow-lib";
const reportSettingsDefault = Object.fromEntries(
  Object.entries(REPORT_OPTIONS).map(([key, option]) => [key, option.default]),
) as unknown as EmailReportSettings;

export const defaultSeasonValues = (): SeasonDetails => {
  return {
    enabled: false,
    instructions: "",
    report: {
      emailList: [],
      reportSettings: {
        ...reportSettingsDefault,
      },
    },
    sitemaps: [],
    serviceOptions: [],
    requiredImageCount: 0,
    requireNotes: true,
    requireReportEmails: true,
    requireSiteMap: true,
  };
};
